import { init, browserTracingIntegration } from '@sentry/svelte'

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn) return

  init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [
      browserTracingIntegration(),
    ],
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 0,
  })
}
